import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './src/App.tsx'
import { AuthProvider } from './src/contexts/AuthContext'
import { QueryProvider } from './src/providers/QueryProvider'
import { loadRuntimeConfig, validateEnvironment } from './src/config/environment'
import './styles/globals.css'

// Loading component
function LoadingScreen() {
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div>Loading configuration...</div>
    </div>
  );
}

// Error component
function ErrorScreen({ error }: { error: string }) {
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div style={{ color: 'red' }}>Configuration Error: {error}</div>
    </div>
  );
}

// Initialize app with runtime configuration
async function initializeApp() {
  try {
    // Load runtime configuration
    await loadRuntimeConfig();
    
    // Validate configuration
    const validation = validateEnvironment();
    if (!validation.valid) {
      throw new Error(`Missing configuration: ${validation.missing.join(', ')}`);
    }
    
    // Render the app
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <BrowserRouter>
          <QueryProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </QueryProvider>
        </BrowserRouter>
      </React.StrictMode>,
    );
  } catch (error) {
    console.error('Failed to initialize app:', error);
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <ErrorScreen error={error instanceof Error ? error.message : 'Unknown error'} />
    );
  }
}

// Show loading screen initially
ReactDOM.createRoot(document.getElementById('root')!).render(<LoadingScreen />);

// Initialize app
initializeApp();